<template>
  <el-upload class="upload-demo" action="/uploadFile" ref="upload" :auto-upload="false" :on-change="selecteFile"
    :on-remove="removeFile" accept=".xls,.xlsx" :limit="1" :file-list="fileList">
    <el-button size="small" type="primary">点击上传</el-button>
    <p @click="downloadTemplate" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p>
    <div slot="tip" class="el-upload__tip">{{ tipText }}</div>
  </el-upload>
</template>
<script>
import * as XLSX from 'xlsx';

export default {
  aname: 'tooltipButton',
  props: {
    templateUrl: {
      type: String,
      required: true,
    },
    /**
     * XLSX.utils.sheet_to_json的选项参数
     * header: 控制输出格式
     *         header            Description
     *         1                 生成数组类型的数组 ("二维数组")
     *         "A"               行对象的键是文字的列标题
     *         array of strings  在行对象内使用指定的字符串作为键
     *         (default)         读取并消除第一行的歧义作为键
     * 其他参考 https://github.com/rockboom/SheetJS-docs-zh-CN#json
     */
    option: {
      type: Object,
      default: null,
    },
    tipText: {
      type: String,
      default: '只能上传xls/xlsx文件，且不超过500KB',
    },
  },
  data() {
    return {
      fileList: [],
    };
  },
  computed: {},
  created() {
    if (!this.templateUrl) {
      this.$message.show({ text: '使用组件请传入模板URL', type: 'warning' });
    }
  },
  methods: {
    selecteFile(file, _fileList) {
      const that = this;
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'array' }); // XLSX.read(data, read_opts) attempts to parse data
        const wsname = workbook.SheetNames[0]; // 取第一张表
        const fileData = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], this.option); // 生成json表格内容
        that.$emit('change', fileData);
      };
      fileReader.readAsArrayBuffer(file.raw);
    },
    removeFile() {
      this.$emit('remove');
    },
    downloadTemplate() {
      if (!this.templateUrl) {
        return;
      }
      window.location.href = this.templateUrl;
    },
    downloadErrorInfoFile(header, arr, widthList = []) {
      const data = [];
      for (let i = 0; i <= arr.length; i += 1048570) {
        data.push(arr.slice(i, i += 1048570));
      }
      const sheetList = [];
      data.forEach((item, index) => {
        sheetList[index] = XLSX.utils.json_to_sheet([header, ...item], { skipHeader: true });
        if (!sheetList[index]['!cols']) {
          sheetList[index]['!cols'] = [];
        }
        if (widthList.length) {
          widthList.forEach((width, colIndex) => {
            if (!sheetList[index]['!cols'][colIndex]) {
              sheetList[index]['!cols'][colIndex] = {};
            }
            sheetList[index]['!cols'][colIndex].wch = width;
          });
        }
      });

      const wb = XLSX.utils.book_new();
      sheetList.forEach((item, index) => {
        XLSX.utils.book_append_sheet(wb, item, `Sheet${index + 1}`);
        XLSX.writeFile(wb, '导入结果.xlsx');
      });
    },
  },
};
</script>
<style scoped>
.item {
  display: inline-block;
  /* float: right; */
  /* margin-top: 10px; */
}
</style>



// WEBPACK FOOTER //
// src/components/base/uploadExcelToJson.vue